import React, { useState, useEffect } from 'react';
import { emailApi } from '../../api';
import { PageHeader, Table, Pagination, Modal, FormItem, message, formatDate } from '../../components/common';

const AdminEmails = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10, total: 0 });
  const [sort, setSort] = useState({ field: 'created_at', order: 'desc' });
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({ recipient_email: '', subject: '', content: '' });

  const fetchEmails = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        per_page: pagination.per_page,
        sort_by: sort.field,
        order: sort.order
      };
      // Object.keys(params).forEach(k => !params[k] && delete params[k]);
      const res = await emailApi.getList(params);
      setEmails(res.data.items);
      setPagination(prev => ({ ...prev, total: res.data.total }));
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchEmails(); }, [pagination.page, pagination.per_page, sort]);

  const handleSort = (field, order) => {
    setSort({ field, order });
  };

  const handleSend = () => {
    setFormData({ recipient_email: '', subject: '', content: '' });
    setModalVisible(true);
  };

  const handleSubmit = async () => {
    try {
      await emailApi.send(formData);
      message.success('邮件发送成功');
      setModalVisible(false);
      fetchEmails();
    } catch (err) {
      message.error(err.message);
    }
  };

  const statusMap = { pending: { text: '待发送', class: 'tag-warning' }, sent: { text: '已发送', class: 'tag-success' }, failed: { text: '发送失败', class: 'tag-error' } };

  const columns = [
    { key: 'id', title: 'ID', width: '60px', sorter: true },
    { key: 'sender_name', title: '发送者' },
    { key: 'recipient_email', title: '收件人', sorter: true },
    { key: 'subject', title: '主题' },
    { key: 'related_type', title: '关联类型', render: (v) => v ? ({ account: '账号', sales: '销售' }[v] || v) : '-' },
    { key: 'status', title: '状态', render: (v) => <span className={`tag ${statusMap[v]?.class}`}>{statusMap[v]?.text}</span>, sorter: true },
    { key: 'sent_at', title: '发送时间', render: (v) => formatDate(v), sorter: true },
  ];

  return (
    <div>
      <PageHeader title="邮件记录" extra={<button className="btn btn-primary" onClick={handleSend}>发送邮件</button>} />

      <Table
        columns={columns}
        data={emails}
        loading={loading}
        sort={sort}
        onSort={handleSort}
      />
      <Pagination current={pagination.page} total={pagination.total} pageSize={pagination.per_page}
        onChange={(page) => setPagination(prev => ({ ...prev, page }))}
        onPageSizeChange={(size) => setPagination(prev => ({ ...prev, per_page: size, page: 1 }))} />

      <Modal visible={modalVisible} title="发送邮件" onClose={() => setModalVisible(false)}
        footer={<><button className="btn btn-default" onClick={() => setModalVisible(false)}>取消</button>
          <button className="btn btn-primary" onClick={handleSubmit}>发送</button></>}>
        <FormItem label="收件人邮箱" required>
          <input type="email" value={formData.recipient_email} onChange={e => setFormData({ ...formData, recipient_email: e.target.value })} />
        </FormItem>
        <FormItem label="邮件主题" required>
          <input value={formData.subject} onChange={e => setFormData({ ...formData, subject: e.target.value })} />
        </FormItem>
        <FormItem label="邮件内容" required>
          <textarea rows={6} value={formData.content} onChange={e => setFormData({ ...formData, content: e.target.value })} />
        </FormItem>
      </Modal>
    </div>
  );
};

export default AdminEmails;
